<template>
  <div class="ny-sidebar">
    <el-scrollbar>
      <el-menu
        v-if="data.length"
        :unique-opened="true"
        router
        :default-active="defaultActive"
        :default-openeds="defaultOpeneds"
        @open="handleOpen"
        @close="handleClose"
        @select="handleSelect"
        :collapse="isCollapse"
      >
        <ny-submenu :data="data"></ny-submenu>
    </el-menu>

      <ny-loading v-else :loading="effect"></ny-loading>
    </el-scrollbar>
    <span class="ny-sidebar__collapse" @click="handleCollapse">{{isCollapse ? '展开' : '关闭'}}</span>
  </div>
</template>

<script>
import NySubmenu from './submenu'
import NyLoading from '../common/loading'

export default {
  name: 'Sidebar',
  components: {
    NySubmenu,
    NyLoading
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    defaultActive: String,
    defaultOpeneds: {
      type: Array,
      default: () => []
    },
    effect: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      isCollapse: false
    }
  },
  methods: {
    handleCollapse () {
      this.isCollapse = !this.isCollapse
      this.$emit('on-collapse', this.isCollapse)
    },
    handleOpen (index, indexPath) {
      this.$emit('on-open', index, indexPath)
    },
    handleClose (index, indexPath) {
      this.$emit('on-close', index, indexPath)
    },
    handleSelect (index, indexPath) {
      this.$emit('on-select', index, indexPath)
    }
  }
}
</script>

<style lang="scss">
@include b(ny-sidebar) {
  position: fixed;
  top: 45px;
  left: 0;
  height: 100%;
  // max-width: 200px;
  background-color: #121414;
  z-index: 1000;
  transition: all 0.3s;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  .el-scrollbar__view >.el-menu {
    padding-top: 85px;
    padding-bottom: 45px;
  }
  .el-menu {
    width: 200px;
    border-right: none;

    &.el-menu--collapse {
      width: 64px;

      > .ny-submenu {
        > .el-menu-item,
        > .el-submenu > .el-submenu__title {
          span,
          .el-submenu__icon-arrow {
            display: none;
          }
        }
      }
    }
  }

  @include e(collapse) {
    position: absolute;
    top: 0;
    right: -40px;
    color: white;
    width: 40px;
    padding: 6px 0;
    font-size: 12px;
    text-align: center;
    border-bottom-right-radius: 10px;
    background-color: #121414;
    cursor: pointer;
  }

  .el-menu {
    background-color: #121414;
  }
  .el-submenu {
    @include is(opened) {
      .el-submenu__title {
        i {
          transform: translateY(-50%) rotateZ(180deg);
        }
      }
    }

    .el-menu {
      background-color: #a3102b;
    }
  }

  .el-submenu__title,
  .el-menu-item {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #fff;
    border-left: 4px solid transparent;

    i {
      margin-right: 6px;
      margin-top: 0;
      color: #fff;
      transform: translateY(-50%);
    }

    &:hover,
    &.is-active {
      // color: #A3102B;
      border-left-color: #ec3328;
      background: #a3102b;
    }
  }
}
</style>
